import React from 'react';
import './MarkingAlert.css';
import ValidationMessages from "../utils/validationMessages";

const MarkingAlert = (props) => {
    const { handleCancelalert, markingalert, areasMarkedCount, hasPSLEntry } = props;

    let message;
    if (areasMarkedCount > 0 && !hasPSLEntry) {
        message = ValidationMessages.psl;
    } else if (areasMarkedCount === 0 && !hasPSLEntry) {
        message = ValidationMessages.marker;
    }

    return (
        <div>
            {markingalert && (
                <div className="alert-overlay">
                    <div className="alert">
                        <p>{message}</p>
                        <div className="button-container">
                            <button onClick={() => handleCancelalert(false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MarkingAlert;